<template>
  <div class="view pa24">
    <div class="d-flex">
      <div>
        <el-select
          @change="typeName"
          v-model="categoriesValue"
          class="w120 mb10 mr10"
          :placeholder="$t('merchandise', 'goodsCategory')"
        >
          <el-option
            :label="allText"
            value="全部"
          >
          </el-option>
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.name"
            :value="item.goodstypeId"
          >
          </el-option>
        </el-select>
        <el-input
          class="w120 mb10 mr10"
          :placeholder="$t('merchandise', 'goodsName')"
          v-model="filterName"
        />

        <!--
        <el-select
          @change="putaway"
          v-model="shelvesValue"
          class="w120 mb10 mr10"
          placeholder="是否上架"
        >
          <el-option
            v-for="(item, index) in ['全部','是', '否']"
            :key="index"
            :label="item"
            :value="index"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="distributionValue"
          @change="agency"
          class="w120 mb10 mr10"
          placeholder="是否分销"
        >
          <el-option
            v-for="(item, index) in ['是', '否']"
            :key="index"
            :label="item"
            :value="index"
          >
          </el-option>
        </el-select> -->
        <el-button type="primary"  @click="filterNames">{{ $t('merchandise', 'search') }}</el-button>
      </div>
      <div style="margin-left: auto">
        <!-- <el-button class="ma mr10 mb10" @click="TPublic">批量上架</el-button>
        <el-button class="ma mr10 mb10" @click="FPublic">批量下架</el-button>
        <el-button class="ma mr10 mb10" @click="delAll">批量删除</el-button> -->
        <el-button class="ma" type="primary" @click="getRedactOrAdd()"
          >{{ $t('merchandise', 'addGoods') }}</el-button
        >
      </div>
    </div>

    <commonTable
      :tableData="tableData"
      :total="total"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :loading="loading"
    >
      <template v-slot:table>
        <!-- <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column> -->

        <el-table-column prop="goodsId" align="center" width="100" :label="$t('merchandise', 'goodsNumber')" />
        <el-table-column prop="goodPhoto" align="center" :label="$t('merchandise', 'goodsImage')">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.goodPhoto"
              style="width: 100px; height: 80px;margin-bottom:-10px"
              :src="scope.row.goodPhoto"
            ></el-image>
            <p
              v-else
              style="width: 100px; height: 80px;line-height: 80px;margin-bottom:-10px"
            >
              {{ $t('merchandise', 'noImage') }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsName"
          align="center"
          :label="$t('merchandise', 'goodsName')"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="goodsTypeName"
          align="center"
          width="150"
          :label="$t('merchandise', 'category')"
          show-overflow-tooltip
        />
        <el-table-column
          prop="maxPrice"
          align="center"
          width="120"
          :label="$t('merchandise', 'price')"
          show-overflow-tooltip
        />
        <el-table-column
          prop="maxWholesalePrice"
          align="center"
          width="120"
          :label="$t('merchandise', 'wholesalePrice')"
          show-overflow-tooltip
        />
        <el-table-column prop="stockNum" width="100" align="center" :label="$t('merchandise', 'totalStock')" />
        <el-table-column prop="dealNum" width="100" align="center" :label="$t('merchandise', 'totalSales')" />
        <el-table-column prop="createTime" width="200px" align="center" :label="$t('merchandise', 'publishTime')">
          <template slot-scope="scope">
              {{ scope.row.createTime | getDataTimeSec }}
            </template>
        </el-table-column>
        <el-table-column prop="resaleLevel" width="100" align="center" :label="$t('merchandise', 'resaleStatus')">
          <template slot-scope="scope">
            {{ scope.row.resaleLevel && scope.row.resaleLevel > 0 ? $t('merchandise', 'yes') : $t('merchandise', 'no') }}
          </template>
        </el-table-column>
        <el-table-column prop="resaleCount" width="120" align="center" :label="$t('merchandise', 'resaleCount')">
          <template slot-scope="scope">
            {{ scope.row.resaleCount || 0 }}
          </template>
        </el-table-column>
         <el-table-column prop="" align="center" :label="$t('merchandise', 'sort')">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="$t('merchandise', 'sortTip')" placement="top-start">
              <el-input v-model="scope.row.sort"  :placeholder="$t('merchandise', 'sortTip')" @change="saveSort(scope.row)"/>
            </el-tooltip>
          </template>
        </el-table-column>
        <!--  <el-table-column
            prop="distributionRatioOrAmount"
            align="center"
            label="分销比例/金额"
          /> -->

        <!-- <el-table-column prop="isPublic" align="center" label="是否上架">
          <template slot-scope="scope">
            <el-button
              @click="isPublic(scope.row)"
              v-if="scope.row.isPutOn"
              type="text"
              size="mini"
              >下架</el-button
            >
            <el-button
              @click="isPublic(scope.row)"
              type="text"
              v-else
              size="mini"
              >上架</el-button
            >
          </template>
        </el-table-column> -->

        <el-table-column align="center" width="300" :label="$t('merchandise', 'operation')">
          <template slot-scope="scope">
            <el-button plain size="mini" @click="getDetails(scope.row)"
              >{{ $t('merchandise', 'details') }}</el-button
            >
            <el-button
              type="primary"
              plain
              size="mini"
              @click="getRedactOrAdd(scope.row)"
              >{{ $t('merchandise', 'edit') }}</el-button
            >
            <customPopconfirm
              :confirm-button-text="$t('common', 'confirm')"
              :cancel-button-text="$t('common', 'cancel')"
              @confirm="del(scope.row)"
              icon="el-icon-info"
              icon-color="red"
              :title="$t('merchandise', 'confirmDelete')">
                <el-button
                  type="danger"
                  size="mini"
                  class="ma ml10 mb10"
                  slot="reference"
                  plain
                  >{{ $t('merchandise', 'delete') }}</el-button
                >
            </customPopconfirm>
            <el-button
              @click="isPublic(scope.row)"
              size="mini"
              v-if="scope.row.isPutOn"
              class="ma ml10 mb10"
              >{{ $t('merchandise', 'offline') }}</el-button
            >
            <el-button
              @click="isPublic(scope.row)"
              class="ma ml10 mb10"
              v-else
              size="mini"
              >{{ $t('merchandise', 'online') }}</el-button
            >
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
// @ts-ignore
import commonTable from "@/components/common/commonTable";
import customPopconfirm from "@/components/common/customPopconfirm";
import { getDataTimeSec } from "@/utils";


// @ts-ignore
import {
  getGoodsInfo,
  getGoodsTypeInfo,
  delGoods,
  updateOnline,
  updateGoodsSort
} from "@/api/coupon.js";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "productList",
  mixins: [i18nMixin],
  components: {
    commonTable,
    customPopconfirm
  },
  props:{
    jurisdiction:{
        type: Boolean,
        default: false,
    },
  },

  data() {
    return {
      userInfo: this.$store.state.loginRoot.userInfo,
      options: [],
      categoriesValue: "全部", //商品分类
      shelvesValue: "", //是否上架
      distributionValue: "", //是否分销
      tableData: [],
      filterName: "", //搜索\
      tableDataF: [], //筛选
      delGoods: [],
      page:1,
      loading: false, //加载中\
      total:0,
      pageNum:1,
      pageSize:10,
    };
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    }
  },
  computed: {
    // 动态获取"全部"的文本
    allText() {
      return this.$t('merchandise', 'all');
    }
  },
  methods: {
    handleSelectionChange(value) {
      this.delGoods = value;
    },

    //批量上架
    TPublic() {
      if (this.delGoods.length > 0) {
        let promises = [];
        for (let i = 0; i < this.delGoods.length; i++) {
          const data = {
            goodsId: this.delGoods[i].goodsId,
            isPutOn: true,
          };
          promises.push(updateOnline(data));
        }
        Promise.all(promises)
          .then(() => {
            this.$message.success(this.$t('merchandise', 'operationSuccess'))
            this.get();
          })
          .catch(err => {
            if(err.code == 201){
              this.$message({
                message: err.message,
                type: "warning",
              });
            }else{
              this.$message.error(this.$t('merchandise', 'operationFailed'))
            }
            this.get();
          });
      }
    },

    //上下架
    isPublic(row) {
      if(this.jurisdiction || this.userInfo.roleId){
        const data = {
          goodsId: row.goodsId,
          isPutOn: !row.isPutOn,
        };
        updateOnline(data)
        .then(res=>{
          if(res.code == 200){
            this.$message.success(this.$t('merchandise', 'operationSuccess'))
            this.get();
          }else{
            this.$message.error(this.$t('merchandise', 'operationFailed'))
          }
        })
        .catch(err => {
          if(err.code == 201){
            this.$message({
              message: err.message,
              type: "warning",
            });
          }else{
            this.$message.error(this.$t('merchandise', 'operationFailed'))
          }
        });
      }else{
        this.$message({
            type: "warning",
            message: this.$t('merchandise', 'noPermission'),
          });
        return
      }

    },

    //批量下架
    FPublic() {
      if (this.delGoods.length > 0) {
        let promises = [];
        for (let i = 0; i < this.delGoods.length; i++) {
          const data = {
            goodsId: this.delGoods[i].goodsId,
            isPutOn: false,
          };
          promises.push(updateOnline(data));
        }
        Promise.all(promises)
          .then(() => {
            this.$message.success(this.$t('merchandise', 'operationSuccess'))
            this.get();
          })
          .catch(err => {
            if(err.code == 201){
              this.$message({
                message: err.message,
                type: "warning",
              });
            }else{
              this.$message.error(this.$t('merchandise', 'operationFailed'))
            }
            this.get();
          });
      }
    },

    //批量删除
    delAll() {
      this.delGoods.map((itme) => {
        delGoods({ goodsId: itme.goodsId });
      });
      if (this.delGoods.length > 0) {
        this.$message({
          message: this.$t('merchandise', 'operationSuccess'),
          type: "success",
          center: true,
        });
      }
      this.get();
      this.delGoods = [];
    },

    //获取商品
    async get() {
      let param = {
        goodsName: this.filterName,
        goodstypeId: this.goodstypeId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.loading = true;
      const { data } = await getGoodsInfo(param); //商品列表
      if (data) {

       let val =  JSON.parse(data.pageInfo);
        console.log(val)
        this.tableData = val.list
        this.total = val.total
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].goodPhoto) {
            this.tableData[i].maxPrice  =  (this.tableData[i].maxPrice / 100 ).toFixed(2)
            this.tableData[i].maxWholesalePrice = this.tableData[i].maxWholesalePrice ? (this.tableData[i].maxWholesalePrice / 100).toFixed(2) : '-'
            this.tableData[i].goodPhoto = this.tableData[i].goodPhoto.split(
              ","
            )[0];
          }
        }
        this.tableDataF = this.tableData;
        this.loading = false;
      } else {
        this.tableData = [];
         this.loading = false;
      }
    },

    //搜索类名
    typeName(value) {
      if (value === '全部' || value === this.allText) {
        this.goodstypeId = undefined; // 选择"全部"时不传递分类ID
      } else {
        this.goodstypeId = value;
      }
    },

    //搜索上架
    putaway(value) {
      if (value == 0) {
        this.tableData = this.tableDataF.filter((item) => item.isDistribution);
      } else {
        this.tableData = this.tableDataF.filter((item) => !item.isDistribution);
      }
    },

    //搜索分销
    agency(value) {
      if (value == 0) {
        this.tableData = this.tableDataF.filter((item) => item.isPublic);
      } else {
        this.tableData = this.tableDataF.filter((item) => !item.isPublic);
      }
    },

    //商品详情
    getDetails(row) {
      this.$router.push({
        path: `/goodsDetails`,
        query: { details: JSON.stringify(row) },
      });
    },

    //商品管理
    getRedactOrAdd(row) {

      if(this.userInfo.roleId || this.jurisdiction){
        if (row) {
          this.$router.push({
            path: "/redactOrAdd",
            query: {
              id: row.goodsId,
            },
          });
        } else {
          this.$router.push({
            path: "/redactOrAdd",
          });
        }
      }else{
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
    },
    //输入框搜索
    async filterNames() {
      this.get();
    },
    //删除弹窗
    del(row) {
      if(this.jurisdiction || this.userInfo.roleId){
        delGoods({ goodsId: row.goodsId })
        .then(() => {
          this.$message({
            message: this.$t('merchandise', 'operationSuccess'),
            type: "success",
            center: true,
          });
          this.get();
        })
        .catch(() => {
          this.$message({
            message: this.$t('merchandise', 'operationFailed'),
            type: "warning",
            center: true,
          });
        });
      }else{
        this.$message({
            type: "warning",
            message: this.$t('merchandise', 'noPermission'),
          });
        return
      }
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.get();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.currentPage = 1;
      this.get();
    },
    async saveSort(row){
      if(row && row.sort != ""){
        console.log(row)
        const result = await updateGoodsSort(row);
        console.log("result:",result)
        this.$message({
          type: "info",
          message: this.$t('merchandise', 'saveSuccess'),
        });
      }else{
        this.$message({
          type: "error",
          message: this.$t('merchandise', 'sortCannotEmpty'),
        });
      }
    },
    // 加载分类数据
    async loadCategories() {
      try {
        const datas = await getGoodsTypeInfo({}); //获取分类数据
        this.options = datas?.data || [];
      } catch (error) {
        console.error('Failed to load categories:', error);
        this.options = [];
      }
    }
  },
  //生命周期
  async created() {
    this.get();
    await this.loadCategories();
  },
  mounted() {
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', async () => {
      await this.loadCategories();
      // 强制更新组件以反映语言变化
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  }
};
</script>

<style lang="scss" scoped></style>
